import styles from './Icon.module.scss';

type IconProps = {
  src: string;
  alt: string;
  id?: string;
  width?: number;
  height?: number;
  onClick?: (element: any) => any;
  className?: string,
  lazy?: boolean;
}

const Icon = ({ src, alt, id, width = 16, height = 16, onClick, className, lazy = false }: IconProps) => {
  const computedClassName = [
    onClick && styles.clickable,
    className
  ].filter(Boolean).join(' ');

  return (
    <img
      src={src}
      alt={alt}
      id={id}
      data-test-id={id}
      data-testid={id}
      width={width}
      height={height}
      onClick={onClick}
      className={computedClassName || null}
      loading={lazy ? 'lazy' : 'eager'}
    />
  );
};

export default Icon;
